// extracted by mini-css-extract-plugin
export default {"amenity":"_Zpp9Y"};